import api from '../api';

export const coOrdinatorApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllStudents: builder.query({
      query: () => ({
        url: '/api/tenant/student/fetch/associated/students/summary',
        method: 'GET'
      })
    }),
    getAllStudentsAudits: builder.query({
      query: ({ page, size, search, sortBy, sortOrder }) => ({
        url: '/api/tenant/student/fetch/associated/students',
        method: 'POST',
        body: {
          page,
          size,
          search,
          sortBy,
          sortOrder
        }
      }),
      providesTags: ['GetAllStudentAudits']
    }),
    createCoOrdinatorStudent: builder.mutation({
      query: ({ body }) => ({
        url: '/api/tenant/student/create',
        method: 'POST',
        body: { ...body }
      })
    }),
    fetchStudentProfile: builder.query({
      query: userId => ({
        url: '/api/tenant/student/student/getProfile',
        method: 'GET',
        params: { userId }
      })
    }),
    sendVerificationMail: builder.query({
      query: userId => ({
        url: '/api/tenant/student/student/resend/invitation',
        method: 'GET',
        params: { userId }
      })
    }),
    updateStudentProfile: builder.mutation({
      query: ({ userId, body }) => ({
        url: '/api/tenant/student/update/studentProfile',
        method: 'PUT',
        params: { userId },
        body
      }),
      invalidatesTags: ['GetAllStudentAudits']
    }),
    deleteStudentProfile: builder.mutation({
      query: userId => ({
        url: '/api/tenant/student/delete/studentProfile',
        method: 'DELETE',
        params: { userId }
      }),
      invalidatesTags: ['GetAllStudentAudits']
    }),
    importStudents: builder.mutation({
      query: ({ body, skipMobileNumValidation }) => ({
        url: '/api/tenant/student/import',
        method: 'POST',
        body,
        params: { skipMobileNumValidation }
      }),
      invalidatesTags: ['GetAllStudentAudits']
    }),
    assignCompanyTests: builder.mutation({
      query: () => ({
        url: '/api/tenant/student/assign/company/tests',
        method: 'POST'
      }),
      invalidatesTags: ['GetAllStudentAudits']
    }),
    assignDriveTests: builder.mutation({
      query: () => ({
        url: '/api/tenant/student/assign/drive/tests',
        method: 'POST'
      }),
      invalidatesTags: ['GetAllStudentAudits']
    }),
    assignCloudprepTests: builder.mutation({
      query: () => ({
        url: '/api/tenant/student/assign/cloudprep/tests',
        method: 'POST'
      }),
      invalidatesTags: ['GetAllStudentAudits']
    })
  })
});

export const {
  useGetAllStudentsQuery,
  useLazyGetAllStudentsAuditsQuery,
  useCreateCoOrdinatorStudentMutation,
  useLazyFetchStudentProfileQuery,
  useUpdateStudentProfileMutation,
  useDeleteStudentProfileMutation,
  useLazySendVerificationMailQuery,
  useImportStudentsMutation,
  useAssignCompanyTestsMutation,
  useAssignDriveTestsMutation,
  useAssignCloudprepTestsMutation
} = coOrdinatorApi;
